import { Send } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

/**
 * La zone où l'on écrit. Entrée envoie, Maj+Entrée passe à la ligne.
 * Elle grandit avec le texte, sans jamais dépasser quelques lignes.
 */
export function Saisie({
  onEnvoyer,
  bloque,
  raisonBlocage,
  texteInitial,
  cleSuggestion,
}: {
  onEnvoyer: (texte: string) => void;
  bloque: boolean;
  raisonBlocage?: string;
  /** Une suggestion cliquée arrive ici, prête à être envoyée. */
  texteInitial?: string;
  /** Change à chaque clic, pour que le même exemple cliqué deux fois arrive deux fois. */
  cleSuggestion?: number;
}) {
  const [texte, setTexte] = useState('');
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (texteInitial) {
      setTexte(texteInitial);
      ref.current?.focus();
    }
  }, [texteInitial, cleSuggestion]);

  const envoyer = () => {
    if (bloque || !texte.trim() || texte.length > 2000) return;
    onEnvoyer(texte);
    setTexte('');
  };

  return (
    <div>
      <div className="focus-within:border-primary-500 focus-within:ring-primary-100 flex items-end gap-2 rounded-xl border border-neutral-300 bg-white p-2 transition-colors focus-within:ring-2">
        <textarea
          ref={ref}
          rows={1}
          value={texte}
          onChange={e => setTexte(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              envoyer();
            }
          }}
          disabled={bloque}
          placeholder="Que voulez-vous faire ?"
          aria-label="Votre demande"
          className="field-sizing-content max-h-40 min-h-10 flex-1 resize-none bg-transparent px-2 py-2 text-sm leading-6 text-neutral-900 outline-none placeholder:text-neutral-500/50 disabled:opacity-60"
        />
        <button
          type="button"
          onClick={envoyer}
          disabled={bloque || !texte.trim() || texte.length > 2000}
          aria-label="Envoyer"
          className="bg-brand-500 hover:bg-brand-600 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-white transition-colors disabled:opacity-40"
        >
          <Send className="h-4 w-4" />
        </button>
      </div>
      {texte.length > 1800 && (
        <p
          className={`mt-2 text-xs ${texte.length > 2000 ? 'text-error-600' : 'text-neutral-500'}`}
        >
          {texte.length.toLocaleString('fr-FR')} /{' '}
          {(2000).toLocaleString('fr-FR')} caractères
        </p>
      )}
      {bloque && raisonBlocage && (
        <p className="mt-2 text-xs text-neutral-500">{raisonBlocage}</p>
      )}
    </div>
  );
}
